import React from 'react';
import { motion } from 'framer-motion';
import { ScaleIcon } from 'lucide-react';
export function CostOfInaction() {
  const costs = [{
    problem: 'Recetas de YouTube que no te quedan igual',
    cost: 'Ingredientes tirados, plata perdida'
  }, {
    problem: 'Sin fórmula de precios',
    cost: 'Trabajás horas y no ganás nada'
  }, {
    problem: 'Packaging armado con lo que tenés',
    cost: 'Vergüenza de mostrar el producto'
  }, {
    problem: 'Sin sistema de redes',
    cost: 'Nunca llegás a nuevos clientes'
  }, {
    problem: 'Sin las recetas Sin TACC',
    cost: 'Perdés un mercado enorme'
  }, {
    problem: 'Otro fin de semana sin vender nada',
    cost: 'El mismo ciclo, el mes que viene'
  }];
  return <section className="w-full bg-white py-8 md:py-16" data-id="element-30">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-32">
          <div className="text-center mb-6 md:mb-12" data-id="element-33">
            <div className="flex justify-center mb-4 md:mb-6" data-id="element-34">
              <div className="bg-red-500/10 p-4 rounded-full" data-id="element-35">
                <ScaleIcon className="w-12 h-12 text-red-500" data-id="element-36" />
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2 md:mb-4" data-id="element-37">
              ⚖️ ¿CUÁNTO TE CUESTA NO TENERLO?
            </h2>
          </div>

          <div className="bg-orange-50 border border-red-200 rounded-lg overflow-hidden mb-6 md:mb-10" data-id="element-38">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-white border-b border-red-200" data-id="element-39">
              <div className="font-bold text-gray-900" data-id="element-40">Sin el Mega Pack</div>
              <div className="font-bold text-red-500" data-id="element-41">Costo real</div>
            </div>

            {costs.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.4
          }} className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border-b border-red-100 last:border-b-0" data-id="element-42">
                <div className="text-gray-600" data-id="element-43">{item.problem}</div>
                <div className="text-red-500 font-semibold" data-id="element-44">{item.cost}</div>
              </motion.div>)}
          </div>

          <motion.h3 initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-2xl md:text-4xl font-bold text-orange-500 text-center" data-id="element-45">
            La próxima semana puede ser diferente.
          </motion.h3>
        </motion.div>
      </div>
    </section>;
}